/* sgb004 */

(() => {
	class CustomSearchSubtitle {
		resultElement = null;
		filtersTextElement = null;

		constructor() {
			this.addEventListeners();
			this.buildSubtitle();
		}

		addEventListeners() {
			const originalPushState = history.pushState;
			const _this = this;

			history.pushState = function (...args) {
				originalPushState.apply(this, args);

				_this.waitForSearchGroElements();
			};
		}

		buildSubtitle() {
			const resultElement = document.getElementById('result-dextop');

			if (!(resultElement instanceof HTMLElement)) {
				this.waitForSearchGroElements();
			} else {
				this.resultElement = resultElement;
				this.addSubtitle();
			}
		}

		waitForSearchGroElements() {
			const targetNode = document.getElementById('id_ts7_app_page_main_div');

			if (!(targetNode instanceof HTMLElement)) {
				return;
			}

			const observer = new MutationObserver((mutations) => {
				const resultElement = document.getElementById('result-dextop');

				if (resultElement instanceof HTMLElement) {
					observer.disconnect();

					this.resultElement = resultElement;
					this.addSubtitle();
				}
			});

			observer.observe(targetNode, {
				childList: true,
				subtree: true,
			});
		}

		buildContentSubtitle() {
			let filtersTextElement = this.resultElement.querySelector(
				'.custom-filters-text'
			);

			if (!(filtersTextElement instanceof HTMLElement)) {
				const searchTextElement = this.resultElement.querySelector('span');
				filtersTextElement = document.createElement('span');

				filtersTextElement.classList.add('custom-filters-text');

				this.resultElement.insertBefore(filtersTextElement, searchTextElement);

				this.filtersTextElement = filtersTextElement;
			}
		}

		getFilters() {
			const urlParams = new URLSearchParams(location.search);
			const filtersRaw = urlParams.get('filters');
            return JSON.parse(filtersRaw) ?? {};
		}

		existsLabel(name, value) {
			const element = document.querySelector(
				`label.ts7-filter-label:has(input[name="${name}"][value="${value}"]) span.ts7-filter-option`
			);

			return element instanceof HTMLSpanElement;
		}

		getLabel(name, texts, def) {
			const labels = [];

			if (Array.isArray(texts)) {
				for (const text of texts) {
					if (this.existsLabel(name, text)) {
						labels.push(text);
					}
				}
			}

			return labels.length == 0 ? def : labels.join(', ');
		}

		hasMultipleResults(){
			return document.querySelectorAll('#ts7-search-result .ts7-search-row .ts7-search-grid').length > 1;
		}

		makePlural(text){
			let result = text;

			if( this.hasMultipleResults() ){
				const words = {'property': 'properties', 'lot': 'lots', 'department': 'departments', 'house': 'houses'};

				for( const word in words ){
					result = result.replaceAll(word, words[word]);
				}
			}

			return result;
		}

		buildText(texts) {
			const place = `${texts['city']} ${texts['country']}`.trim();
			let text = '';

			if (texts['development']) {
				text = `${text} at <span class="text development">${texts['development']}</span>`;
			}

			if (place) {
				text = `${text} in <span class="text city">${texts['city']}</span> <span class="text country">${texts['country']}</span>`;
			}

			if (texts['developer']) {
				text = `${text} by <span class="text developer">${texts['developer']}</span>`;
			}

            if( text !== '' || texts['property type'] !== '' ){
				let propertyTypeText = texts['property type'] === '' ? 'property' : texts['property type'];

				propertyTypeText = this.makePlural(propertyTypeText);
				propertyTypeText = `<span class="text property-type">${propertyTypeText}</span>`;

                text = `${propertyTypeText} ${text}`;
            }

			return text;
		}

		getText() {
			const filters = this.getFilters();
			const texts = {
				'property type': '',
				city: '',
				country: '',
				development: '',
				developer: '',
			};

			for (const name in texts) {
				texts[name] = this.getLabel(name, filters[name], texts[name]);
			}

			return this.buildText(texts);
		}

		addSubtitle() {
			const text = this.getText();

			if (text) {
				this.buildContentSubtitle();
				this.filtersTextElement.innerHTML = this.getText();
			}
		}
	}

	function handleReady() {
		new CustomSearchSubtitle();
	}

	document.addEventListener('DOMContentLoaded', handleReady);
})();